import React from 'react';
const rows = [['Panic-planning the night before', '10 minutes with the Meeting Picker'], ['Ideas that fill 15 minutes', 'Full meetings for 45, 60 or 90'], ['“Our meetings are boring”', 'Hook, challenge, game, campfire close'], ['Faking knots and compass in front of kids', 'The skill explained to you first'], ['Rain cancels the plan', 'A Rain Swap in every meeting']];
export function CostOfInaction() {
  return <section className="w-full bg-pine" data-id="element-62" data-mp="34via718t6sm2">
      <div className="mx-auto max-w-3xl px-5 py-14 sm:py-20" data-id="element-63" data-mp="38xlnzwiya9ai">
        <h2 className="text-center font-display text-[28px] leading-tight text-paper sm:text-4xl" data-id="element-64" data-mp="38w26y3pgzu7o">
          What another year of winging it costs you
        </h2>
        <div className="mt-8 overflow-hidden rounded-2xl border border-paper/15" data-id="element-65" data-mp="3inod3lmyb33k">
          <div className="grid grid-cols-2 text-center" data-id="element-66" data-mp="3nmrl9ey89pfr">
            <div className="border-r border-paper/15 bg-signal px-3 py-3 font-display text-base text-white sm:text-lg" data-id="element-67" data-mp="3nocdgxx2kwag">
              Winging it
            </div>
            <div className="bg-forest px-3 py-3 font-display text-base text-white sm:text-lg" data-id="element-68" data-mp="3egpzpuwo3xz9">
              Troop Night Ready
            </div>
          </div>
          {rows.map(([bad, good]) => <div key={bad} className="grid grid-cols-2 border-t border-paper/15 text-[13px] leading-snug sm:text-sm" data-id="element-69" data-mp="34jblm1y7vla4">
              <div className="border-r border-paper/15 px-3.5 py-3.5 text-paper/60 line-through decoration-signal/60" data-id="element-70" data-mp="11jz332untjb">
                {bad}
              </div>
              <div className="px-3.5 py-3.5 font-semibold text-paper" data-id="element-71" data-mp="3s8ebty6x2mg8">{good}</div>
            </div>)}
        </div>
      </div>
    </section>;
}